import { render } from "./CxOptions.vue?vue&type=template&id=2bd56b6b&scoped=true"
import script from "./CxOptions.vue?vue&type=script&lang=js"
export * from "./CxOptions.vue?vue&type=script&lang=js"

import "./CxOptions.vue?vue&type=style&index=0&id=2bd56b6b&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd56b6b"]])

export default __exports__